<template>
	<div id="tax" ref='tax' style="padding: 0; height: 100%" v-loading="loading">
		<sbspSalaryFilter :filterList.sync="filterList">
			<el-form-item label="税金月份：" style="margin-right:40px;">
				<div style="display:flex;align-items: center;">
					<el-select v-model="filterList[0].value" placeholder="请选择" style="width:110px;" @change="dateWageChange()">
						<el-option v-for="item in filterList[0].options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
          <el-date-picker class="el-date" v-if="filterList[0].value=='92480004'" v-model="taxTime.month"  style="width:230px;margin-left:4px;"
                          type="monthrange"
                          range-separator="至"
                          value-format="yyyy-MM"
                          start-placeholder="开始月份"
                          end-placeholder="结束月份">
          </el-date-picker>
				</div>
			</el-form-item>

		</sbspSalaryFilter>
		<div class="carBox" ref="carBox" >
				<div v-if="cardDatas.length== 0&&showNodata" style="margin: 0 auto;">
				<noData style="margin-top: 200px;" msg="暂无数据"></noData>
			</div>
			<cardTwo v-for="(cardData,i) in cardDatas" :key="i" :cardData='cardData' :labels='labels' style="min-height: 230px;" :keys='keys'>
				<div class="leftButtonCon">
          <div v-if="cardData.taxPayStatus!='92630003'">
            <leftButton title="反馈报税结果" @click="_queryLeavePerson(cardData,i)" style="top:74px;"></leftButton>
          </div>
					<!--<leftButton title="工资明细" @click="Jump({path: '/wage/wagesDetailList',query:{batchId:cardData.id,taxType:cardData.taxType,taxCompanyName:cardData.taxCompanyName,taxReportTime:cardData.taxReportTime,taxReportStatus:cardData.taxReportStatus,taxPayStatus:cardData.taxPayStatus}})"
					 style="top:99px;"></leftButton>-->
					<leftButton title="税金明细"
					@click="Jump({path: '/wage/taxDetailList',
					query:{
						batchId:cardData.id,
						taxType:cardData.taxType,
						taxCompanyName:cardData.taxCompanyName,
						taxReportTime:cardData.taxMonth,
						taxReportStatus:cardData.taxReportStatus,
						taxPayStatus:cardData.taxPayStatus
						}})"
					 style="top:124px;"></leftButton>
					<leftButton title="下载申报表" @click="download(cardData)" ></leftButton>
				</div>
			</cardTwo>
		</div>
		<p class="more">
			<span @click="moreData()" v-if="cardDatas.length==6">查看更多></span>
		</p>
		<el-dialog ref="testDialog" width="420px" v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false"
		 title="反馈报税结果" :visible.sync="dialogFormVisible">
			<div class="flex1">
				<div @click="changeReportStatus()">
					<div class="align_center">
						<svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-yishenbao"></use>
						</svg>
					</div>
					<span class="checkbox" :class="{'checked':currentData.taxReportStatus&&currentData.taxReportStatus.trim()=='92490003'}"></span><span>已申报</span>
				</div>
				<div @click="changePayStatus()">
					<div  class="align_center">
						<svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-yijiaokuan"></use>
						</svg>
					</div>
					<span class="checkbox" :class="{'checked':currentData.taxPayStatus&&currentData.taxPayStatus.trim()=='92630003'}"></span><span>已缴款</span>
					</div>
			</div>
       <div class="warm-tip" v-show="isShow" >
         <div class="warm-tip-flex">
           <h3>温馨提示:</h3>
           <p>存在可能漏报税员工，请注意核查<br>(上月有报税记录，当月没有)
             <el-popover popper-class="loopBox" placement="bottom-start" width="296" trigger="hover">
               <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:red;">
                 <use xlink:href="#icon-cuowu"></use>
               </svg>
               <div class="loopError" >
                 <div class="loopType loopTypeError">
                   <div class="loopContent" >
                     <div class="text-indent">提示:</div>
                     {{leaveName}}
                   </div>
                 </div>
               </div>
             </el-popover>
           </p>
         </div>
       </div>
			<div style="text-align: center;margin-top: 20px">
				<el-button type="primary" @click="updateStauts">
					提交
				</el-button>
			</div>
		</el-dialog>
	</div>

</template>

<script>
	import sbspSalaryFilter from "@/wage-components/sbs-salary-filter/sbsp-salary-filter.vue"
	import cardTwo from "@/wage-components/sbs-salary-card/cardTwo.vue"
	import noData from "@/wage-components/bsp-noData/bsp-noData.vue"
	import leftButton from "@/wage-components/sbs-salary-card/left-button.vue"
	import exportMethod from "@/util/export"
	import {
		getTaxList,
		updateTaxBatch,
		getTaxBatchById,
    getTaxCompanyList,
    queryLeavePerson
	} from "@/api/tax/tax"
	import {exportExcleSheets} from "@/api/common/common"
	import { downloadFile } from '@/util/util';

	export default {
		name: "approval",
		components: {
			sbspSalaryFilter,
			cardTwo,
			leftButton,
			noData
		},
		data() {
			return {
        tipFlag:'',
        leaveName:'',
				msgPage: {
					limit: 6,
					page: 1,
					total: 0,
          monthStr:'92480001',
          monthStart:'',
		  monthEnd:'',

		},
		showNodata:false,
        taxTime:{
          month:'',
        },
				currentData: {},
				loading:false,
        flag:true,
				currentIndex: 0,
				isBottom: false,
				labels: ["发薪人数", "税金总额", "工资总额"],
				keys: ['taxPerNum', 'payAccount', 'taxAccount'],
				dialogFormVisible: false,
				cardDatas: [],
				filterList: [/*{
						text: "税金申报月份",
						type: 'select-timer',
						value: '',
						value2: '',
						name: 'taxMonth',
						options: [{
							value: new Date().getMonth() == 0 ? (new Date().getFullYear() - 1 + '-12') + ',' + (new Date().getFullYear() +
									'-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1))) :
								(new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (
									new Date().getMonth() + 1))) + ',' + (new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ?
									'0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1))),
							label: '当前月'
						}, {
							value: new Date().getMonth() == 1 ? (new Date().getFullYear() - 1 + '-12') + ',' + (new Date().getFullYear() +
									'-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1))) :
								(new Date().getFullYear() + '-' + ((new Date().getMonth() - 1) < 10 ? '0' + (new Date().getMonth() - 1) : (
									new Date().getMonth() - 1))) + ',' + (new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ?
									'0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1))),
							label: '三月内'
						}, {
							value: new Date().getFullYear() - 1 + '-' + (((new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() +
								1) : (new Date().getMonth() + 1))) + ',' + new Date().getFullYear() + '-' + (((new Date().getMonth() + 1) <
								10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1))),
							label: '一年内'
						}, {
							value: 'qt',
							label: '其他'
						}]
					},*/
          { text: "税金申报月份", type: 'select-timer',value:'92480002',name:'taxMonth',
            options:[{
              value: '92480001',
              label: '当前月'
            }, {
              value: '92480002',
              label: '近三个月'
            }, {
              value: '92480003',
              label: '近一年'
            },{
              value: '92480004',
              label: '其他'
            }]
          },
					{
						text: "报税主体",
						type: 'select',
						value: [],
            multiple:true,
						name: 'taxCompanyList',
            defaultGroupProps:{
              label: 'taxCompanyName',
              value: 'id',
            },
            options: []
					},
          { text: "申报状态", type: 'select',value:[],multiple:true,name:'taxReportStatus',dicts:'9249'},
          { text: "缴纳状态", type: 'select',value:[],multiple:true,name:'taxPayStatus',dicts:'9263'},
        ]
			};
		},
		created() {
			this.filterLists = JSON.parse(JSON.stringify(this.filterList))
      this._getTaxCompanyList();
			// this._getTaxList();

		},
		watch: {
			filterList: { //深度监听，可监听到对象、数组的变化
				handler(val, oldVal) {
					val.map((item) => {
						if (item.value2) {
							this.$set(this.msgPage, item.name, item.value2);
						} else {
							if (item.value2 == '' && item.value) {
								this.$set(this.msgPage, item.name, item.value.split(','));
							} else {
								this.$set(this.msgPage, item.name, item.value);
							}
						}
					})
					this.$set(this.msgPage, 'page', 1);
					if (this.msgPage.taxMonth == '92480004') {
						return;
					}
					this._getTaxList();
				},
				deep: true //true 深度监听
			},
      taxTime:{
        handler(val, oldVal){

          let month = val.month;
          this.$set(this.msgPage,'monthStart',month[0]);
          this.$set(this.msgPage,'monthEnd',month[1]);
          this._getTaxList();
        },
        deep:true //true 深度监听
      }
		},
		mounted() {
			window.addEventListener('scroll', () => {
				if(this.$refs.carBox&&this.cardDatas.length!=6){
					var top = this.$refs.carBox.getBoundingClientRect().top;
					var height = this.$refs.carBox.clientHeight;
					if (top + height - document.getElementsByClassName('main')[0].clientHeight < 60) {
						this.moreData();
					}
				}
			}, true);
		},
		methods: {
      dateWageChange(val){
        if(this.filterList[0].value!='92480004'){
          this.$set(this.msgPage,'monthStart','');
          this.$set(this.msgPage,'monthEnd','');
        }
      },
			_getTaxList() {
				this.loading = true;
				getTaxList(this.msgPage).then(res => {
					this.cardDatas = res.data.records;
          this.loading = false;
					this.showNodata = true;
				})
			},
      changeReportStatus() {
        if(this.currentData.taxReportStatus==='92490003'){
           if (this.currentData.taxPayStatus==='92630003'){
             this.$message.error('已缴款不能修改申报状态');
           }else{
             this.$set(this.currentData, 'taxReportStatus', '');
           }
        }else {
          this.$set(this.currentData, 'taxReportStatus', '92490003');
        }
        this.$forceUpdate();
			},
      changePayStatus() {
        if(this.currentData.taxReportStatus==='92490003'){
           if (this.currentData.taxPayStatus==='92630003'){
             this.$set(this.currentData, 'taxPayStatus', '');
           }else {
             this.$set(this.currentData, 'taxPayStatus', '92630003');
           }
        }else {
          this.$set(this.currentData, 'taxPayStatus', '92630003');
          this.$set(this.currentData, 'taxReportStatus', '92490003');

        }

        this.$forceUpdate();
      },
			_getTaxBatchById(cardData, i) {
        /*this._queryLeavePerson()*/;
        this.dialogFormVisible = true;
				this.currentIndex = i;
        Object.assign(this.currentData, cardData);
			},
    _queryLeavePerson(cardData, i){
       queryLeavePerson(this.currentData).then(res => {
             this.tipFlag = res.data.flag;
             this.leaveName = res.data.leavePerson;
            if(this.tipFlag =='10020001'){
              this.isShow =true;
            }else{
              this.isShow =false;
            }
        })
          this._getTaxBatchById(cardData, i);
      },
      _getTaxCompanyList() {
        getTaxCompanyList().then(res => {
          let rs = res.data;
            this.filterList[1].options = rs;
            this.filterLists = JSON.parse(JSON.stringify(this.filterList));

        })
      },
			updateStauts() {
        if(this.currentData.taxReportStatus=='92490003'){
          updateTaxBatch(this.currentData).then(res => {
            this.dialogFormVisible = false
            this.$message.success('修改成功');
            this.loading = true;
            getTaxBatchById(this.currentData.id).then(res => {
              this.cardDatas.splice(this.currentIndex, 1, res.data.data);
              this.loading = false;

            })
          })
        }else {
          this.$message.error('请勾选报税结果');
        }


			},
			Jump(path) {
				this.$router.push(path);
			},
			moreData() {
				if (this.isBottom) {
					return;
				}
				this.$set(this.msgPage, 'page', this.msgPage.page + 1);
				getTaxList(this.msgPage).then((res) => {
					if (res.data.records.length < this.msgPage.limit) {
						this.isBottom = true;
					}
					this.cardDatas = this.cardDatas.concat(res.data.records)
				})
			},
			download(cardData){
				exportExcleSheets({
							columns:[],
							type: "excel",
							beanName: "taxServiceImpl",
							methodName: "exportTax",
							batchId: 	cardData.id,
							taxType:	cardData.taxType,
              taxMonth: cardData.taxMonth,
							isSort: true,
							headerRowNum: 1,
							fileName: cardData.taxMonth+cardData.taxCompanyName+"申报表",
							fileType: ".xls",
						},"/wage").then(res => {
					downloadFile(res)
				})
			}
		}
	};
</script>

<style scoped>
	.el-date.el-date-editor >>> 	 .el-range__close-icon{
			line-height: 20px;
		}
	  .carBox {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.more span {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(64, 158, 255, 1);
		line-height: 18px;
		cursor: pointer;
	}

	.more {
		text-align: right;
		padding-right: 10px;
	}

	.more span:hover {
		text-decoration: underline;
	}

	.flex1 {
		display: flex;
		justify-content: space-around;
	}

	.flex1>div {
		cursor: pointer;
	}
	.flex1>div span{
		vertical-align: middle;
	}
	.flex1>div span:nth-last-of-type(1) {
		font-size: 12px;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		margin-left: 10px;
	}

	.checkbox {
		display: inline-block;
		box-sizing: border-box;
		width: 13px;
		height: 13px;
		border-radius: 2px;
		border: 1px solid rgba(220, 220, 220, 1);
		position: relative;
		cursor: pointer;
	}

	.checkbox.checked::after {
		content: '';
		position: absolute;
		width: 20px;
		height: 15px;
		background: url('../../../assets/img/dataImport/dui.svg') no-repeat;
		top: -4px;
		background-size: 100%;
	}

	.light-theme #main #tax {
		background: #f8f8f8;
		box-shadow: none;
	}
	.align_center{
		text-align: center;
		margin-bottom: 10px;
	}
	.align_center .icon{

		font-size: 60px;
	}
	#tax >>> .el-dialog__header{
		    background: none;
    text-align: center;
    padding-top: 20px;
		font-size:16px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
	}
   .warm-tip{
     margin-top: 15px;
     padding-right: 11px;
   }
  .warm-tip h3{
      text-align: center;
      font-size: 12px!important;
      font-weight: 600;
      color: #333;
    }
  .warm-tip-flex{
    display: flex;
    justify-content: center;
  }
  .warm-tip-flex p{
    font-size: 12px!important;
    color: #666;
  }
</style>
<style>
  .vxe-table:not(.is--empty).show--foot.scroll--x .vxe-table--body-wrapper {
    overflow-x: hidden!important;
  }
</style>
